// extracted by mini-css-extract-plugin
module.exports = {"container":"StepText_container__2AOXp","callout":"StepText_callout__2aMN_"};